export default {
  addShopSuccess: 'Artikel erfolgreich hinzugefügt',
  addShopFail: 'Artikel konnte nicht hinzugefügt werden',
  getCartDataFail: 'Fehler beim Abrufen der Warenkorbartikel',
  hint: 'Hinweis',
  delConfirmProduct: 'Möchten Sie dieses Produkt wirklich löschen?',
  confirm: 'Bestätigen',
  cancel: 'Abbrechen',
  productInfo: 'Produktdetails',
  unitPrice: 'Stückpreis',
  num: 'Menge',
  subtotal: 'Zwischensumme',
  action: 'Aktion',
  productName: 'Produktname',
  splitProduct: 'Produkt aufteilen',
  split: 'Aufteilen',
  allSelect: 'Alle auswählen',
  delProduct: 'Ausgewählte entfernen',
  selected: 'Ausgewählt',
  piece: 'Artikel',
  total: 'Gesamt',
  productTotal: 'Exkl. internationaler Versandkosten',
  orderPay: 'Zur Kasse',
  orderTotal: 'Bestellsumme',
  goCartPay: 'Warenkorb anzeigen',
  moreView: 'Weitere Artikel im Warenkorb',
  noSelectText: 'Sie haben noch keine Produkte ausgewählt',
  paySuccess: 'Zahlung erfolgreich!',
  returnPayment: 'Zurück zur Fortsetzung der Zahlung',
  service: 'Service',
  goodsMinNumErrTips:
    'Für dieses Produkt gilt eine Mindestabnahmemenge von {num}. Sie können nach Bedarf verschiedene Spezifikationen auswählen.',
  balckShop: 'Der Shop steht auf der schwarzen Liste',
  forbidBuy: 'Risikoshop, Kauf verboten',
  riskTip: 'Risikoshops, bitte mit Vorsicht kaufen',
  riskReminder: 'Risikohinweis',
  blackenedShop: 'Gesperrter Shop',
  riskProducts: 'Risikoprodukte',
  riskMsg1:
    'Es besteht möglicherweise ein gewisses Risiko im Zusammenhang mit den von Ihnen eingereichten Produkten. Zu Ihrer finanziellen Sicherheit können wir Ihnen derzeit keine Online-Bestelldienste anbieten. Für weitere Informationen wenden Sie sich bitte an den Kundenservice oder den Spezialisteneinkauf.',
  riskMsg2:
    'Bei den von Ihnen eingereichten Produkten besteht möglicherweise ein gewisses Versandrisiko. Zu Ihrer finanziellen Sicherheit können wir Ihnen vorübergehend keine Online-Bestelldienste anbieten. Für weitere Informationen wenden Sie sich bitte an den Online-Kundenservice!',
  riskMsg3:
    'Bei dem von Ihnen gekauften Produkt kann es sich um einen Spezial- oder Markenartikel handeln. Uns fehlt die Möglichkeit, seine Echtheit zu überprüfen, und wir können nur Beschaffungs- und grundlegende Qualitätsprüfungsdienste anbieten. Alle potenziellen Risiken müssen von Ihnen getragen werden.',
  continueToBuy: 'Weiter einkaufen',
  buyOthers: 'Andere kaufen',
  continuePurchasing: 'Weiter einkaufen',
}
